export default "__VITE_ASSET__c868ae92__"